"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomThemes = void 0;
var theme_1 = require("../types/theme");
var birdsOfParadise = __importStar(require("../themes/birdsOfParadise.json"));
var cobalt = __importStar(require("../themes/cobalt.json"));
var darkModern = __importStar(require("../themes/darkModern.json"));
var dracula = __importStar(require("../themes/dracula.json"));
var github = __importStar(require("../themes/github.json"));
var githubDark = __importStar(require("../themes/githubDark.json"));
var githubLight = __importStar(require("../themes/githubLight.json"));
var idleFingers = __importStar(require("../themes/idleFingers.json"));
var lightModern = __importStar(require("../themes/lightModern.json"));
var monoIndustrial = __importStar(require("../themes/monoIndustrial.json"));
var monokaiProSpectrum = __importStar(require("../themes/monokaiProSpectrum.json"));
var pastelsOnDark = __importStar(require("../themes/pastelsOnDark.json"));
var slushAndPoppies = __importStar(require("../themes/slushAndPoppies.json"));
var xcode = __importStar(require("../themes/xcode.json"));
exports.CustomThemes = (_a = {},
    _a[theme_1.CustomTheme.BIRDS_OF_PARADISE] = {
        data: birdsOfParadise,
        standalone: true,
    },
    _a[theme_1.CustomTheme.COBALT] = {
        data: cobalt,
        standalone: true,
    },
    _a[theme_1.CustomTheme.DARK_MODERN] = {
        data: darkModern,
        standalone: false,
    },
    _a[theme_1.CustomTheme.DRACULA] = {
        data: dracula,
        standalone: true,
    },
    _a[theme_1.CustomTheme.GITHUB] = {
        data: github,
        standalone: true,
    },
    _a[theme_1.CustomTheme.GITHUB_DARK] = {
        data: githubDark,
        standalone: true,
    },
    _a[theme_1.CustomTheme.GITHUB_LIGHT] = {
        data: githubLight,
        standalone: true,
    },
    _a[theme_1.CustomTheme.IDLE_FINGERS] = {
        data: idleFingers,
        standalone: true,
    },
    _a[theme_1.CustomTheme.LIGHT_MODERN] = {
        data: lightModern,
        standalone: false,
    },
    _a[theme_1.CustomTheme.MONO_INDUSTRIAL] = {
        data: monoIndustrial,
        standalone: true,
    },
    _a[theme_1.CustomTheme.MONOKAI_PRO_SPECTRUM] = {
        data: monokaiProSpectrum,
        standalone: true,
    },
    _a[theme_1.CustomTheme.PASTELS_ON_DARK] = {
        data: pastelsOnDark,
        standalone: true,
    },
    _a[theme_1.CustomTheme.SLUSH_AND_POPPIES] = {
        data: slushAndPoppies,
        standalone: true,
    },
    _a[theme_1.CustomTheme.XCODE] = {
        data: xcode,
        standalone: true,
    },
    _a);
